import Parse from 'parse';
global.Parse = Parse;
export * from '@parse/react-base';
export var initializeParse = function (serverURL, applicationId, javascriptKey) {
    Parse.serverURL = serverURL;
    Parse.initialize(applicationId, javascriptKey);
    Parse.enableLocalDatastore();
};
//# sourceMappingURL=index.js.map